import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { isEqual } from "lodash";

// UI Components
import BootstrapTable from "react-bootstrap-table-next"; // https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import paginationFactory from "react-bootstrap-table2-paginator";
import { toastr } from "react-redux-toastr";
import { Container, Card, CardBody } from "reactstrap";

// State
import { registerUser } from "../../../state/actions/userActions";
import { getUsers, selectUser, updateUserPermissions } from "../../../state/actions/adminActions";

// Custom Components
import { Group } from "../../../utils/logger";
import Loader from "../../../components/Loader";
import Header from "./Header";
import AddUserModal from "./AddUser.Modal";
import user_table_schema from "./userTableSchema";
import querystring from "querystring";

class UserPermissions extends Component {
  constructor(props) {
    super(props);

    // Get query string and parse into object
    const query_string = window.location.search.replace(/^\?/, "");
    const query_object = querystring.parse(query_string);

    this.state = {
      search_text: query_object.user || "",
      users: props.users,
      selected: props.selected,
    };

    this.LoggerGroup = new Group("UserPermissions", { disable: true });

    this.onUserAction = this.onUserAction.bind(this);
    this.onSearchUsers = this.onSearchUsers.bind(this);
  }

  componentDidMount() {
    this.LoggerGroup.emit("Mounted").end();

    this.props.getUsers();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const state = {};

    if (!isEqual(nextProps.users, prevState.users)) {
      state.users = nextProps.users;
    }
    if (!isEqual(nextProps.selected, prevState.selected)) {
      state.selected = nextProps.selected;
    }

    return state;
  }

  onSearchUsers({ target }) {
    // this.LoggerGroup.emit("Searching value", target.name, target.value);

    this.setState({ search_text: target.value });
  }

  onUserAction(type, user, group_id_bint) {
    this.LoggerGroup.emit("User Action triggered", { dir: user });
    this.props.selectUser(user);

    switch (type) {
      case "update":
        this.LoggerGroup.emit(`  [i] Updating User[${user}] to permission[${group_id_bint}]`);
        user.group_id_bint = group_id_bint;

        this.props.updateUserPermissions({ ...user });
        break;

      case "delete":
        this.LoggerGroup.emit(`  [i] Deleting User`);
        return toastr.warning("We do not currently allow users to be deleted");
      // toastr.confirm("Are you sure you want to delete this user?", {
      //   okText: "Delete User",
      //   onCancel: () => this.LoggerGroup.emit(`Cancelled delete user[${user.user_id_bint}]`),
      //   onOk: () => this.props.deleteUser(user),
      // });
      // break;

      default:
        return this.LoggerGroup.emit({ error: `Invalid user action type[${type}]` });
    }

    this.LoggerGroup.end();
  }

  render() {
    const { loading, admin_user } = this.props;
    const { onUserAction } = this;
    const { search_text, users, selected } = this.state;

    if (loading && !users.length) {
      return <Loader />;
    }

    const search_text_regex = new RegExp(search_text, "i");
    const filtered_users = users.filter(
      (user) =>
        /^\d+$/.test(search_text)
          ? user.user_id_bint === parseInt(search_text) // Search by id
          : search_text_regex.test(user.firstname_vch) || search_text_regex.test(user.lastname_vch) // Search by text
    );

    return (
      <Container fluid className="p-0">
        <Header searchText={search_text} onSearchUsers={this.onSearchUsers} />

        <Card>
          <CardBody>
            <AddUserModal />

            <p>You can use the dropdowns below to update a user's permission level.</p>
            <p>Note: You may not raise someone's permission higher than yours.</p>
          </CardBody>

          <CardBody>
            <BootstrapTable
              bootstrap4
              hover
              classes="table-responsive-md"
              keyField="user_id_bint"
              data={filtered_users}
              columns={user_table_schema({ admin_user, onUserAction })}
              bordered={false}
              pagination={paginationFactory({
                sizePerPage: 10,
                sizePerPageList: [5, 10, 25, 50, 75, 100],
              })}
              defaultSorted={[
                {
                  dataField: "firstname_vch",
                  order: "asc",
                },
              ]}
              rowClasses={(user) => {
                return user.user_id_bint === selected.user_id_bint ? "table-info" : null;
              }}
            />
          </CardBody>
        </Card>
      </Container>
    );
  }
}

UserPermissions.propTypes = {
  errors: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  admin_user: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  selected: PropTypes.object.isRequired,

  getUsers: PropTypes.func.isRequired,
  selectUser: PropTypes.func.isRequired,
  registerUser: PropTypes.func.isRequired,
  updateUserPermissions: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  errors: state.admin.errors,
  loading: state.admin.loading.users,
  admin_user: state.user.user,
  users: state.admin.users,
  selected: state.admin.selectedUser,
});

export default connect(mapStateToProps, {
  getUsers,
  selectUser,
  registerUser,
  updateUserPermissions,
})(UserPermissions);
